module.exports = __webpack_public_path__ + "static/contact-top-img-1d8a1e03aae5ad1e0685accfa40225f4.png";